module.exports = __webpack_public_path__ + "img/unodc_logo-tran.e6c43e00.png";